export default {"src":"/_next/static/media/document.10ec4483.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};